import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import mediumZoom from 'medium-zoom';

import Typography from '../typography/typography';

import {
  Grid,
  Subgrid,
  ImageArea,
  Image,
  NameArea,
  DescriptionArea,
} from './styles';

const Product = ({ title, image, description, ...rest }) => {
  const imageRef = useRef(null);

  useEffect(() => {
    mediumZoom(imageRef.current);
  }, [imageRef]);

  return (
    <Grid {...rest}>
      <ImageArea>
        <Image
          src={image.localFile.childImageSharp.fluid.src}
          // fluid={image.localFile.childImageSharp.fluid}
          // srcSet={image.localFile.childImageSharp.fluid.srcSet}
          alt={title}
          ref={imageRef}
        />
      </ImageArea>

      <Subgrid>
        <NameArea>
          <Typography variant="h2" className="h3">
            {title}
          </Typography>
        </NameArea>

        <DescriptionArea dangerouslySetInnerHTML={{ __html: description }} />
      </Subgrid>
    </Grid>
  );
};

Product.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  description: PropTypes.string.isRequired,
};

export default Product;
